import * as React from 'react';
import { ButtonLink } from '../ButtonLink/ButtonLink';
import { Box, Display, Visible } from '@gousto-internal/citrus-react';

type GetStartedCTAProps = {
  href?: string | null;
  mobileHidden?: boolean;
  onClick?: () => void;
};

export function GetStartedCTA({
  href = '/signup',
  mobileHidden = false,
  onClick,
}: GetStartedCTAProps) {
  if (!href) return null;
  const cta = (
    <Box width="100%" maxWidth={['unset', null, '320px']}>
      <ButtonLink href={href} onClick={onClick}>
        Get started
      </ButtonLink>
    </Box>
  );
  if (mobileHidden) {
    return <Visible display={[Display.None, Display.None, Display.Block]}>{cta}</Visible>;
  }
  return cta;
}
